export default __webpack_public_path__ + "static/times_now_semibold-webfont-d6a7e6b48897c95eece09544a59673c6.woff2";